import { reatomBoolean } from '@reatom/framework'

export const isOpenUpdateModalAtom = reatomBoolean(
  false,
  'isOpenUpdateModalAtom',
)
